<script>
  // Перенос Grid из parts.tsx — сетка карточек.
  export let size = undefined;   // 'narrow' | 'wide'
</script>

<div class={'mn-grid' + (size ? ' ' + size : '')}><slot /></div>
